import { isDesktopDevice } from "@/utils/device.utils";
import { canAccessDashboard, FeatureFlags } from "@/common/featureFlags";

export const APP_HOME_ROUTE = "/orders";
export const DASHBOARD_HOME_ROUTE = "/dashboard";
export const DASHBOARD_FUNDING_ROUTE = `${DASHBOARD_HOME_ROUTE}/funding`;
export const DASHBOARD_GUEST_FLOW_ROUTE = `${DASHBOARD_HOME_ROUTE}/guest-flow`;
export const DASHBOARD_REPORTS_ROUTE = `${DASHBOARD_HOME_ROUTE}/reports`;
/** Query flag on the funding page that opens the request sheet. */
export const REQUEST_FUNDING_PARAM = "request";
export const LOGIN_ROUTE = "/login";
/** Query parameter on the login pages holding where to go after signing in. */
export const LOGIN_REDIRECT_PARAM = "redirect";

/**
 * The in-app path to open after login, or null when `value` is missing or could leave the app
 * (protocol-relative `//host`, `/\host`, absolute URLs) or points back at a login page.
 */
export const getSafeRedirect = (value: string | null | undefined): string | null => {
  if (!value || !value.startsWith("/") || value.startsWith("//") || value.startsWith("/\\")) return null;
  const path = value.split(/[?#]/, 1)[0];
  if (path === LOGIN_ROUTE || path.startsWith(`${LOGIN_ROUTE}/`)) return null;
  return value;
};

/** The login page, remembering `target` (pathname + search) so the user comes back to it. */
export const getLoginRoute = (target: string): string => {
  const redirect = getSafeRedirect(target);
  return redirect && redirect !== "/"
    ? `${LOGIN_ROUTE}?${new URLSearchParams({ [LOGIN_REDIRECT_PARAM]: redirect })}`
    : LOGIN_ROUTE;
};

/** The safe redirect carried by the current page's query string, if any. */
export const getLoginRedirectFromLocation = (search: string = window.location.search): string | null =>
  getSafeRedirect(new URLSearchParams(search).get(LOGIN_REDIRECT_PARAM));

/**
 * Where a signed-in user lands: the merchant dashboard for dashboard users on a computer,
 * otherwise the regular merchant app.
 */
export const getHomeRoute = (user: { hasDashboardAccess: boolean; featureFlags: FeatureFlags } | null): string =>
  canAccessDashboard(user) && isDesktopDevice() ? DASHBOARD_HOME_ROUTE : APP_HOME_ROUTE;
